import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, Center } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers';
import { useUpdatePassword } from '@olo-web/domain/customer';
import { HookFormInput } from '@olo-web/components/molecules/HookFormInput/HookFormInput.ui';
import { Banner } from '@olo-web/components/atoms/Banner';
import { validationSchema } from './utils/validationSchema';
import { useRouter } from 'next/router';

export function ResetPasswordForm({ onSuccess }: { onSuccess?: (data: any) => void }): JSX.Element {
  const router = useRouter();
  const { resetPwToken } = router.query;

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const { isLoading, error, mutate, reset } = useUpdatePassword({ onSuccess });

  const onSubmit = (data) => {
    mutate({
      token: resetPwToken as string,
      password: data.password,
    });
  };

  return (
    <form style={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)}>
      <HookFormInput
        isRequired
        isUsingYup
        label="Password"
        type="password"
        autoComplete="password"
        errors={errors}
        name="password"
        placeholder="••••••••••••"
        ref={register}
        autoFocus
      />
      <Center mt={6} flexDir="column">
        {error && (
          <Banner
            status="error"
            error={error}
            title="Unable to update your password"
            onClose={reset}
            mb={4}
          />
        )}
        <Button
          w="100%"
          size="lg"
          colorScheme="primary"
          loadingText="Updating..."
          isLoading={isLoading}
          type="submit"
          mb={2}
        >
          Update
        </Button>
      </Center>
    </form>
  );
}
